<!--
 * @ Author: Your name
 * @ Create Time: 2019-05-25 10:25:38
 * @ Modified by: Your name
 * @ Modified time: 2019-08-02 17:11:45
 * @ Description: 设备管理
 -->

<template>
  <div class="content-wrapper">
    <el-form label-width="100px" label-position="right"
      ref="searchForm" :model="formData.data"
      class="search-form" :inline="true">
        <el-form-item label="智能柜编号" prop="deviceNumber">
          <el-input
            size="small" v-model="formData.data.deviceNumber"
            placeholder="智能柜编号" clearable />
        </el-form-item>
        <el-form-item label="智能柜名称" prop="deviceName">
          <el-input
            size="small" v-model="formData.data.deviceName"
            placeholder="智能柜名称" clearable/>
        </el-form-item>
        <el-button type="primary" size="small" class="search-btn"
          @click="searchTableData" icon="el-icon-search"
          :loading="loadingSearch">查询</el-button>
    </el-form>
    <div class="tool-bar">
      <el-button type="danger" size="small" icon="el-icon-plus"
        @click="handleBtn('add')">新增</el-button>
      <el-button type="warning" size="small" icon="el-icon-edit"
        @click="handleBtn('edit')">修改</el-button>
      <el-button type="info" size="small" icon="el-icon-delete"
        @click="handleBtn('del')">删除</el-button>
      <el-button type="success" size="small" icon="el-icon-film"
        @click="handleLinkTo('doorManage')">柜门管理</el-button>
      <el-button type="primary" size="small" icon="el-icon-box"
        @click="handleLinkTo('unpackLog')">开箱日志</el-button>
      <el-button type="warning" size="small" icon="el-icon-open"
        @click='handleBtn("reload", {data: "software"})'>重启智能柜软件</el-button>
      <el-button class="software-btn" size="small" icon="el-icon-open"
        @click='handleBtn("reload", {data: "hardware"})'>重启智能柜硬件</el-button>
      <el-button size="small" icon="el-icon-document"
        @click='getClientLog()' class="client-log">客户端日志</el-button>
    </div>
    <table-pagination
      ref="table"
      :tableData="tableData"
      :height='500'
      :loading='tableLoading'
      service
      @service-fn="handleService"
      @row-click="rowClick">
      <el-table-column label="" width="45" align="center">
        <template slot-scope="scope">
          <el-radio class="radio" v-model="tableRadio" :label="scope.$index">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column prop="deviceNumber" label="智能柜编号" align="center"
        min-width="120" show-overflow-tooltip/>
      <el-table-column prop="deviceName" label="智能柜名称" align="center"
        min-width="120" show-overflow-tooltip/>
      <el-table-column prop="deviceConnPass" label="智能柜连接密码" align="center"
        min-width="160" show-overflow-tooltip/>
      <el-table-column prop="superAdminPass" label="智能柜超级管理员密码" align="center"
        show-overflow-tooltip width="180"/>
      <el-table-column prop="doorCount" label="柜门数量" align="center"
        width="80" show-overflow-tooltip/>
      <el-table-column prop="online" label="是否在线" align="center"
        :formatter="formatOnline" width="80"/>
      <el-table-column prop="onlineTime" label="上线时间"
        align="center" sortable :formatter="formatterTime"  min-width="170"/>
      <el-table-column prop="createBy" label="创建人" align="center"/>
      <el-table-column prop="managerName" label="管理员姓名" align="center" min-width="120"/>
      <el-table-column prop="managerPhone" label="管理员手机号" align="center" min-width="120"/>
      <el-table-column prop="clientVersion" label="客户端版本" align="center" min-width="120"/>
      <el-table-column prop="managerJobCard" label="管理员员工号" align="center" min-width="120"/>
      <el-table-column prop="createDate" label="创建时间" align="center"
        sortable :formatter='formatterTime'  min-width="170"/>
      <el-table-column prop="updateBy" label="更新人" align="center"/>
      <el-table-column prop="updateDate" label="更新时间" align="center"
        sortable :formatter='formatterTime' min-width="170"/>
    </table-pagination>
    <!-- 这是按钮的提示弹窗 -->
    <dialog-tip :handleDialogVisible='handleDialogVisible' :handleBtnTip='handleBtnTip'
      @handleDialogComfirm='handleDialogComfirm("设备")'
      @handleDialogClose='handleDialogClose'>
    </dialog-tip>
    <!-- 这是新增、修改 按钮打开的弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="mainDialogVisible"
      width="760px"
      >
      <dialog-main ref="dialogForm"
        :type="type"
        :id="dialogId"
        :visible='mainDialogVisible'></dialog-main>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mainDialogVisible = false" size="small" type="info">取 消</el-button>
        <el-button @click="handleConfirm('设备')" size="small" type="primary">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="getClientLogTitle"
      width="860px"
      :visible.sync="showDialogClientLog">
      <dialog-client-log
        :deviceNumber='deviceNumbers'
        :timeStamp='timeStamp'>
      </dialog-client-log>
    </el-dialog>
  </div>
</template>

<script>
import { DEVICE_MANAGE } from '../../libs/api'
import tables from '../../mixins/table'
import handleBtn from '../../mixins/dialog/handleBtn'
import dialogMain from './dialogMain.vue'
import dialogClientLog from './dialogClientLog.vue'
import dialogTip from '../../components/dialogTip/index.vue'

export default {
  name: 'deviceManage',
  mixins: [tables, handleBtn],
  components: { dialogMain, dialogTip, dialogClientLog },
  data() {
    return {
      loadingSearch: false,
      tableLoading: false,
      showDialogClientLog: false,
      getClientLogTitle: '',
      getClientLogType: 'getClientLog',
      deviceNumbers: '',
      timeStamp: '',
      formData: {
        pageNum: 1,
        pageSize: 10,
        orderBy: '',
        data: {
          deviceName: '',
          deviceNumber: ''
        }
      },
      dic: { // 字典格式化
        isOnline: {
          1: '是',
          0: '否'
        }
      },
      searchUrl: DEVICE_MANAGE.GET_LIST,
      addUrl: DEVICE_MANAGE.ADD_LIST,
      editUrl: DEVICE_MANAGE.EDIT_LIST,
      restartUrl: DEVICE_MANAGE.RESTAET_LIST,
      delUrl: DEVICE_MANAGE.DEL_LIST,
      getDevNum: DEVICE_MANAGE.GET_DEVICENUM,
      delCheckUrl: DEVICE_MANAGE.DEL_CHECK
    }
  },
  mounted() {
    // table 数据表查询
    this.searchTableData()
  },
  methods: {
    formatOnline(row, column, cellValue) { // 格式化 是否在线
      return this.dic.isOnline[cellValue]
    },
    handleLinkTo(type) { // 跳转至不同的路由 （在跳转的路由页面中，加上一个返回按钮）
      const selectionLen = this.selection.length // 选中的数据条数
      const isSelectOne = this.handleSelectOne(selectionLen, type)
      if (isSelectOne) {
        this.$router.push({ path: `/index/${type}`, query: { path: this.$route.path, deviceNumber: this.selection[0].deviceNumber } })
      }
    },
    async  handleAddEditBefore(type) { // 校验智能柜编号不能重复
      return this.handleGetDevNum(type)
    },
    handleGetDevNum(type) { // 调用 智能柜编号校验接口
      const { deviceNumber } = this.$refs.dialogForm.dialogFormData
      return new Promise((resolve, reject) => {
        if (type === 'add') { // 只有新增时候才校验智能编号唯一性
          this.$http.post(this.getDevNum, { deviceNumber })
            .then(res => {
              if (res.data.data !== 0) {
                resolve({
                  code: false,
                  msg: '新增的智能柜编号已经存在，请重新输入'
                })
              } else {
                resolve({ code: true, msg: '' })
              }
            })
            .catch(err => {
              reject({ code: false, msg: err || '新增错误' })
            })
        } else {
          resolve({
            code: true,
            msg: ''
          })
        }
      })
    },
    async handleDelBefore() { // 删除前校验，判断柜子中是否有东西
      const resReq = await new Promise((resolve, reject) => {
        const { deviceNumber } = this.selection[0]
        this.$http.post(this.delCheckUrl, { deviceNumber })
          .then(res => {
            resolve(res.data.data)
          })
          .catch(err => {
            this.handleNotify('error', '错误', err || '获取柜子物品状态失败')
            reject()
          })
      })
      // 对返回来的数组结果进行遍历， 非0 表示柜子中有航材包
      const delValid = resReq.some(item => item && item !== 0)
      let resTip = '航材柜中没有航材包，确定删除吗？' // 弹窗提示语
      if (delValid) { // 有航材
        resTip = '请注意，航材柜中仍有航材包，确定删除吗？'
      }
      return {
        msg: resTip,
        canDelete: '0'
      }
    },
    searchTableData() {
      this.handleSearch(this.searchUrl, this.formData)
    },
    handleFormatFormdata(type, dialogFormData) {
      const data = { ...dialogFormData }
      if (type === 'add') {
        data.createDate = new Date().getTime()
        data.createBy = ''
      } else { // 修改
        data.updateDate = new Date().getTime()
        data.updateBy = ''
      }
      return {
        data,
        code: 1
      }
    },
    getClientLog() { // 获取客户端日志
      const selectionLen = this.selection.length
      const isSelectOne = this.handleSelectOne(selectionLen, this.getClientLogType) // 只能选一条数据
      if (!isSelectOne) { // 不符合 只选了一条数据
        return false
      }
      const { deviceNumber } = this.selection[0]
      this.deviceNumbers = deviceNumber
      this.getClientLogTitle = `获取客户端日志（当前智能柜编号 ${this.deviceNumbers}）`

      this.showDialogClientLog = true
      this.timeStamp = Date.now()
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.search-form{
  // height: 60px;
  // padding-right: 40px;
  .el-button{
    margin-top: 5px;
  }
}
.tool-bar{
  .client-log{
    background: #5584EB;
    border: none;
    color: #fff;
  }
  .software-btn{
    background: #6CC827;
    color: #fff;
    border: none
  }
}

</style>
